import script from "./nyTit.vue?vue&type=script&setup=true&lang=js"
export * from "./nyTit.vue?vue&type=script&setup=true&lang=js"

import "./nyTit.vue?vue&type=style&index=0&id=d67cfeda&lang=less&scoped=true"
script.__scopeId = "data-v-d67cfeda"

export default script